import React from 'react'
import type { MainImageProps } from './MainImage'

import Image from 'src/comps/Image'

import { getResponsiveImgProps, getThumbnailsToShow } from './utils'
import { thumbnailImageSizes } from './constants'
import { Thumbnail } from './styles'

interface ImagesProps extends MainImageProps {
  isMobile: boolean
  isTablet: boolean
}

const Images = (props: ImagesProps) => {
  const { isMobile, isTablet, pointerEvents, handleClick, photos } = props
  const thumbnailsToShow = getThumbnailsToShow(isMobile, isTablet, photos)

  return (
    <>
      {thumbnailsToShow.map((img, index: number) => {
        const imageProps = getResponsiveImgProps(img, thumbnailImageSizes)
        return (
          <Thumbnail key={img.path} data-testid="gallery-thumbnail" {...pointerEvents}>
            <Image
              alt={`thumbnail-${index}`}
              onClick={() => (isMobile ? handleClick(index) : handleClick(index + 1))}
              {...imageProps}
              loading={index === 0 ? 'eager' : 'lazy'}
              preload={index === 0}
            />
          </Thumbnail>
        )
      })}
    </>
  )
}

export default Images
